/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Deep_Wolf_HuntInputs */

const en_calm_deep_wolf_hunt = /** @type {(inputs: Calm_Deep_Wolf_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Source`)
};

const de_calm_deep_wolf_hunt = /** @type {(inputs: Calm_Deep_Wolf_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenquelle`)
};

/**
* | output |
* | --- |
* | "Data Source" |
*
* @param {Calm_Deep_Wolf_HuntInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_deep_wolf_hunt = /** @type {((inputs?: Calm_Deep_Wolf_HuntInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Deep_Wolf_HuntInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_deep_wolf_hunt(inputs)
	return de_calm_deep_wolf_hunt(inputs)
});